import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import { menuDefs } from '../../util/page';

const menuOrder = ['accounting', 'leasing', 'parts', 'service', 'system', 'solutions'];

const MenuWidget = () => {
  const filteredTree = useSelector(state => state.app.filteredTree);

  const isAllowed = (item = '') => {
    for (const tree of filteredTree) {
      if (tree.name && tree.name === item && tree.menu.length) {
        return true;
      }
    }

    return false;
  };

  const menu = menuOrder.map(menuItem => {
    const obj = menuDefs[menuItem];
    const link = obj.link || obj.label;
    const containerClass = classNames('col-md-2', 'col-sm-4', {
      [link]: true,
      disabled: !isAllowed(link),
    });

    return (
      <div className={containerClass} key={`dash-${link}`}>
        <Card className="dash-menu-panel">
          <Link
            style={{ borderBottom: `2px solid ${obj.color}` }}
            className={`dash-menu-link ${link}`}
            to={`/menu/${link}`}
          >
            {obj.label}
            <div className="dash-menu-icon">
              <i className={`fas fa-${obj.icon} fa-fw`} />
            </div>
          </Link>
        </Card>
      </div>
    );
  });

  return (
    <div className="menu-wrapper d-block d-sm-flex">
      {menu}
      <div className="clearfix" />
    </div>
  );
};

export default MenuWidget;
